<template>
    <div class="field">
        <p class="control is-expanded">
            <vue-single-select
                    v-model="managerId"
                    :options="options"
                    option-label="text"
                    placeholder="Select Manager"
                    max-height="150px"
                    :classes="{
                        input: 'input',
                        dropdown: 'user-select-drop-down'
                    }">
            </vue-single-select>
        </p>
    </div>
</template>

<script>
    import VueSingleSelect from "vue-single-select";
    import apiUsers from './../../../../api/apiUsers'
    export default {
        components: {
            VueSingleSelect
        },
        data () {
            return {
                options: [],
            }
        },
        computed: {
            managerId: {
                get() {
                    return this.$store.getters.getUserTransferManager
                },
                set(value) {
                    this.$store.dispatch('setUserTransferManager', value)
                }
            }
        },
        methods: {
            setSelectOptions (users) {
                let list = []

                users.forEach(function(element) {
                    list.push({
                        id: element.id,
                        text: element.name
                    })
                })

                this.options = list
            }
        },
        created() {
            apiUsers
                .managerListRequest()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Users/User/Transfer/ManagerSelect.vue